import React from 'react';
import bandeiraMercosul from "../assets/images/bandeira_mercosul.png";
import bandeiraBrasil from "../assets/images/bandeira_brasil.png";

const PlacaMercosul = ({ numeroPlaca = "" }) => {
  return (
    <div style={{
      width: '250px',
      height: '100px',
      border: '2px solid #000',
      borderRadius: '8px',
      overflow: 'hidden',
      backgroundColor: '#FFF',
      boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.3)'
    }}>
      {/* Parte azul superior */}
      <div style={{
        backgroundColor: '#0033A0',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      }}>
        {/* Bandeira do Mercosul */}
        <div style={{
          width: '24px',
          height: '24px',
          backgroundImage: `url(${bandeiraMercosul})`,
          backgroundSize: 'cover',
          marginLeft: '10px'
        }}></div>

        {/* Texto BRASIL centralizado */}
        <span style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px'
        }}>
          BRASIL
        </span>

        {/* Bandeira do Brasil */}
        <div style={{
          width: '24px',
          height: '16px',
          backgroundImage: `url(${bandeiraBrasil})`,
          backgroundSize: 'cover',
          border: '1px solid white',
          marginRight: '10px',
          marginLeft: 'auto'
        }}></div>
      </div>

      {/* Parte branca da placa */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '70px'
      }}>
        <span style={{
          fontWeight: 'bold',
          letterSpacing: '4px',
          fontSize: '3em',
          color: '#000'
        }}>
          {numeroPlaca}
        </span>
      </div>
    </div>
  );
};

export default PlacaMercosul;

